import(/* webpackMode: "eager" */ "/usr/src/app/sites/pixarlabs.com/src/app/(main)/account/register/page.jsx");
